import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { CoachingTranscript } from '../../../coaching-base/general';
import { TranscriptService as CoachingTranscriptService } from '../../../coaching-base/transcript.service';
import { Dependencies } from '../../../store';
import { pluck } from '../../../store.decorator';
import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import {
    UpdateTranscript,
    updateTranscriptResult,
} from './update-transcript.action';

export const updateTranscriptEpic = (
    action: ActionsObservable<PayloadAction<ActionType, UpdateTranscript>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT),
        mergeMap((act: PayloadAction<ActionType, UpdateTranscript>) => {
            const rootState = pluck<TranscriptDialogState>(
                state.value,
                act.storePath,
            );
            const ctsService = deps.injector.get<CoachingTranscriptService>(
                CoachingTranscriptService,
            );

            let obs: Observable<CoachingTranscript> = of(rootState.transcript);
            if (
                act.payload.transcript.name !== rootState.transcript.name ||
                act.payload.transcript.description !==
                    rootState.transcript.description ||
                act.payload.transcript.focuses !==
                    rootState.transcript.focuses ||
                act.payload.transcript.caSummary !==
                    rootState.transcript.caSummary
            ) {
                obs = ctsService.update(act.payload.transcript);
            }

            return obs.pipe(
                map((ret) => {
                    return updateTranscriptResult(
                        {
                            ...act.payload,
                            transcript: ret,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
